import React, { Component, Fragment, useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FormsInput from '../../Ui/FormsInput'
import { updateObject, checkValidity } from '../../../shared/utility'

const Shipping = (props) =>{
    const formElementsArray = []
    const [checkoutForm, setCheckoutForm] = useState({
        first_name: {
            elementType: 'input',
            variant: 'outlined',
            label: 'First Name',
            name: 'first_name',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        last_name: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Last Name',
            name: 'last_name',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        contact_no: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Contact Number',
            name: 'contact_no',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        address: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Address',
            name: 'address',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        postcode: {
            elementType: 'input',
            variant: 'outlined',
            label: 'Post Code',
            name: 'postcode',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        city: {
            elementType: 'input',
            variant: 'outlined',
            label: 'City',
            name: 'city',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        state: {
            elementType: 'input',
            variant: 'outlined',
            label: 'State',
            name: 'state',
            elementConfig: {
                required: true,
            },
            value: '',
            classname: 'col-md-12 mt-4',
            validation: {
                type: 'select',
                required: true,
                minLength: 3,
                maxLength: 100
            },
        },
        country:{
            
        }
    })

    const inputChangedHandler = (event, controlName) => {
        
        const updatedControls = updateObject(checkoutForm, {
            [controlName]: updateObject(checkoutForm[controlName], {
                value: event.target.value,
                valid: checkValidity(
                    event.target.value,
                    checkoutForm[controlName].validation
                ),
                touched: true
            })
        })
        setCheckoutForm(updatedControls)
    }

    for (let key in checkoutForm) {
        formElementsArray.push({
            id: key,
            config: checkoutForm[key]
        });
    }
    let form = formElementsArray.map(formElement => (
        <FormsInput
            key={formElement.id}
            elementType={formElement.config.elementType}
            elementConfig={formElement.config.elementConfig}
            classname={formElement.config.classname}
            label={formElement.config.label}
            value={formElement.config.value}
            invalid={!formElement.config.valid}
            shouldValidate={formElement.config.validation}
            touched={formElement.config.touched}
            changed={event => inputChangedHandler(event, formElement.id)}
        />
    ))

    return (
        <>
        <h1>Shipping</h1>
        {form}
        </>
    )
    
}
export default Shipping